import useApi from "../../api/useApi";

const useScheduledPostService = () => {

  const {api} = useApi()

  const adminIndex = (callbackSuccess, callbackValidationErrors, filters = {}) => {
    let endpoint = 'admin/scheduled-posts'
    const params = []
    if (filters.status && filters.status !== 'all') params.push('status=' + filters.status)
    if (params.length) endpoint += '?' + params.join('&')

    return api(
      'get',
      endpoint,
      response => callbackSuccess(response),
      errors => callbackValidationErrors(errors),
      error => console.error('adminIndex failed:', error),
    )
  }

  const adminStore = (callbackSuccess, callbackValidationErrors, data) => {
    return api(
      'post',
      'admin/scheduled-posts/store',
      response => callbackSuccess(response),
      errors => callbackValidationErrors(errors),
      error => console.error('adminStore failed:', error),
      data,
    )
  }

  const adminUpdate = (callbackSuccess, callbackValidationErrors, id, data) => {
    return api(
      'post',
      'admin/scheduled-posts/' + id + '/update',
      response => callbackSuccess(response),
      errors => callbackValidationErrors(errors),
      error => console.error('adminUpdate failed:', error),
      data,
    )
  }

  const adminDelete = (callbackSuccess, callbackValidationErrors, id) => {
    return api(
      'post',
      'admin/scheduled-posts/' + id + '/delete',
      response => callbackSuccess(response),
      errors => callbackValidationErrors(errors),
      error => console.error('adminDelete failed:', error),
    )
  }

  const adminAiTextOverview = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'admin/social-media/ai-text-overview',
      response => callbackSuccess(response),
      errors => { if (callbackValidationErrors) callbackValidationErrors(errors) },
      error => console.error('adminAiTextOverview failed:', error),
    )
  }

  return {
    objectType: 'scheduled_post',
    adminIndex,
    adminStore,
    adminUpdate,
    adminDelete,
    adminAiTextOverview,
  }
}

export default useScheduledPostService
